import React from 'react';
import PublicStaticLayout from '../components/PublicStaticLayout';

export default function CguPage() {
  return (
    <PublicStaticLayout title="Conditions générales d'utilisation">
      <p>
        Les présentes conditions régissent l&apos;accès et l&apos;utilisation de l&apos;application{' '}
        <strong>Baromètre Social Temps Réel</strong>. En créant un compte ou en utilisant le
        service, vous acceptez ces conditions.
      </p>

      <h2>Objet du service</h2>
      <p>
        Le service permet de concevoir, diffuser et analyser des micro-sondages anonymes ou
        pseudonymes afin de mesurer le climat social au sein d&apos;une organisation.
      </p>

      <h2>Compte et sécurité</h2>
      <p>
        Vous êtes responsable de la confidentialité de vos identifiants et de toute activité
        réalisée depuis votre compte. Toute utilisation frauduleuse doit être signalée sans délai
        à l&apos;administrateur de la plateforme.
      </p>

      <h2>Usage conforme</h2>
      <p>
        Vous vous engagez à utiliser le service dans le respect du droit du travail, de la vie
        privée et des textes applicables (RGPD, droit des sondages en entreprise le cas échéant).
        Les contenus des sondages ne doivent pas être illicites, discriminatoires ou diffamatoires.
      </p>

      <h2>Disponibilité</h2>
      <p>
        Le service est fourni selon les moyens disponibles. Des interruptions pour maintenance ou
        mise à jour peuvent intervenir ; elles seront, dans la mesure du possible, planifiées ou
        communiquées.
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        La plateforme, ses marques et ses éléments logiciels restent la propriété des éditeurs ou
        de leurs concédants. Aucune licence n&apos;est accordée au-delà du droit d&apos;utiliser le
        service conformément aux présentes.
      </p>

      <h2>Éditeurs</h2>
      <p>
        Application éditée par le{' '}
        <a href="https://www.webmonster.tech" target="_blank" rel="noopener noreferrer">
          Collectif Webmonster
        </a>{' '}
        et{' '}
        <a href="https://www.numera11y.fr" target="_blank" rel="noopener noreferrer">
          numera11y
        </a>
        .
      </p>
    </PublicStaticLayout>
  );
}
